<template lang="pug">
InheritWrapper(v-model="inherit" :readonly="setting.ReadOnly || disabled")
  .briq-form-element
    label {{ label }}
    briq-tooltip(:help="help")
    .removable-line(v-for="n in lineCount")
      input.form-element(
        v-model="innerValues[n-1]"
        :class="{ 'mt-10': n !== 0 }"
        :type="type"
        :step="step"
        :disabled="setting.ReadOnly || disabled ? true : inherit"
        )
      button.remove-line-button.inline(@click="removeLine(n)" v-if="canRemoveLine" :disabled="inherit")
        BriqIcon(name="icon-input-min-icon")
    BriqButton.add-line-button(small @click="addLine" :disabled="!canAddLine || inherit") Add line
    .validation-message(v-if="fieldError") {{ fieldError }}
</template>

<script>
import InheritWrapper from '@v/settings/application/advanced/InheritWrapper.vue'
import { required } from 'vuelidate/lib/validators'
import { isNil } from 'ramda'

export default {
  name: 'StandardInputMultiple',
  components: { InheritWrapper },
  props: {
    setting: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },
  data() {
    return {
      innerValues:
        this.setting.Values.length > 0
          ? this.setting.Values
          : !isNil(this.setting.InheritedSetting)
          ? this.setting.InheritedSetting.Values
          : [],
      inherit: !this.setting.Values || !this.setting.Values.length,
      inheritedValues: !isNil(this.setting.InheritedSetting)
        ? this.setting.InheritedSetting.Values
        : [],
      temporaryInnerValues: [],
    }
  },
  computed: {
    lineCount() {
      return (this.innerValues && this.innerValues.length) || 1
    },
    label() {
      return this.setting.DisplayName
    },
    help() {
      return this.setting.Description
    },
    type() {
      return this.setting.DataType === 'String' ? 'text' : 'number'
    },
    step() {
      return this.setting.DataType === 'Decimal' ? '0.01' : '1'
    },
    canAddLine() {
      const maxOccurs = this.setting.MaxOccurs
      return this.lineCount < maxOccurs || maxOccurs === 0
    },
    canRemoveLine() {
      return this.lineCount > 1
    },
    fieldError() {
      const item = {
        settingKey: this.setting.SettingKey,
        error: false,
      }

      if (this.$v.innerValues.$invalid && this.$v.innerValues.$dirty && this.inherit === false) {
        item.error = true
        this.$bus.$emit('updateErrors', item)

        return `${this.setting.DisplayName} is required`
      }

      this.$bus.$emit('updateFormErrors', item)
      return null
    },
  },
  validations() {
    return {
      innerValues: {
        required,
        $each: {
          required,
        },
      },
    }
  },
  methods: {
    addLine() {
      if (this.canAddLine) this.innerValues.push(null)
    },
    removeLine(lineNumber) {
      if (this.canRemoveLine) this.innerValues.splice(lineNumber - 1, 1)
    },
  },
  watch: {
    innerValues(newValues) {
      this.$emit('change', this.inherit ? [] : newValues)
    },
    inherit(shouldInherit) {
      if (shouldInherit === true) {
        this.temporaryInnerValues = this.innerValues
        this.innerValues = this.inheritedValues
      } else {
        this.innerValues =
          this.temporaryInnerValues !== [] ? this.temporaryInnerValues : this.inheritedValues
      }

      const innerValues = shouldInherit ? [] : this.innerValues
      this.$emit('change', innerValues)
    },
  },
}
</script>

<style scoped lang="stylus">
.removable-line
  display flex

.remove-line-button
  margin-top 4px
  float right
  &:disabled
    cursor not-allowed

.add-line-button
  margin-top 10px

.mt-10
  margin-top 10px
</style>
